import { createSlice } from "@reduxjs/toolkit";

const passwordChangedSlice = createSlice({
  name: "passwordChanged",
  initialState: {
    success: false,
  },
  reducers: {
    setPasswordChangedSuccess: (state) => {
      state.success = true;
    },
    resetPasswordChangedState: (state) => {
      state.success = false;
    },
  },
});

export const { setPasswordChangedSuccess, resetPasswordChangedState } = passwordChangedSlice.actions;
export default passwordChangedSlice.reducer;
